// Small chili-pepper indicator (out of 3) – inline SVG, no emoji.
const Chili = ({ filled }) => (
  <svg
    viewBox="0 0 24 24"
    width="14"
    height="14"
    aria-hidden="true"
    className="inline-block"
  >
    {/* stem */}
    <path
      d="M13.2 4.6c0.9-1 2.4-1.4 3.6-0.8"
      fill="none"
      stroke="hsl(140 30% 35%)"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    {/* body */}
    <path
      d="M13.4 5.4c2.4 0.6 4.4 2.6 4.6 5.4 0.2 3.4-2.6 7.6-7 9-1.4 0.4-2.4-0.6-2-2 1.4-4.4 1.2-9.8 4.4-12.4z"
      fill={filled ? "hsl(8 70% 48%)" : "transparent"}
      stroke={filled ? "hsl(8 70% 38%)" : "hsl(8 50% 65%)"}
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
);

export default function SpiceMeter({ level = 0, total = 3 }) {
  if (!level) return null;
  return (
    <span
      data-testid={`spice-meter-${level}`}
      role="img"
      aria-label={`Schärfegrad ${level} von ${total}`}
      title={`Schärfe ${level}/${total}`}
      className="inline-flex items-center gap-0.5 align-middle ml-2"
    >
      {Array.from({ length: total }).map((_, i) => (
        <Chili key={i} filled={i < level} />
      ))}
    </span>
  );
}
